var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _c("div", { staticClass: "col-sm-12 col-xs-12 box-wrapper" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-6 col-sm-push-6" }, [
          _c("div", { staticClass: "unrestrict-button" }, [
            _vm.member.is_restricted
              ? _c(
                  "button",
                  {
                    staticClass: "btn emergo-red-button",
                    on: {
                      click: function ($event) {
                        return _vm.openConfirmationPopup()
                      },
                    },
                  },
                  [_vm._v(" UnBlock ")]
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "col-xs-12 col-sm-10 img-blk p-0" }, [
            !_vm.member.profile_pic
              ? _c(
                  "div",
                  { staticClass: "profile-pic-edit profile-pic-title-edit" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getInitials(
                            _vm.member.first_name,
                            _vm.member.last_name
                          )
                        ) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
            _vm.member.profile_pic
              ? _c("img", {
                  staticClass: "profile-pic-edit",
                  attrs: { src: _vm.member.profile_pic, alt: "profile-icon" },
                })
              : _vm._e(),
            _c("div", [
              _vm.member.is_restricted
                ? _c("p", { staticClass: "warn-restriction" }, [
                    _vm._v(
                      " You cannot edit the details as Team Member is blocked. "
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "col-sm-6 col-sm-pull-6 col-xs-12" }, [
          _c("div", { staticClass: "row mr-bt-5p" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12 col-md-12 form-group" },
              [_vm._v("First Name")]
            ),
            _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-10" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Name", disabled: "" },
                domProps: { value: _vm.member.first_name },
              }),
            ]),
          ]),
          _c("div", { staticClass: "row mr-bt-5p" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12 col-md-12 form-group" },
              [_vm._v("Last Name")]
            ),
            _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-10" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Name", disabled: "" },
                domProps: { value: _vm.member.last_name },
              }),
            ]),
          ]),
          _c("div", { staticClass: "row mr-bt-5p" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12 col-md-12 form-group" },
              [_vm._v("Email")]
            ),
            _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-10 mb-10" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Email", disabled: "" },
                domProps: { value: _vm.member.email },
              }),
            ]),
          ]),
          _vm.multi_factor_key
            ? _c(
                "div",
                {
                  staticClass: "row",
                  class: _vm.displayIpErrorMsg ? "mr-bt-0p" : "mr-bt-5p",
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-sm-12 col-xs-12 col-md-12 form-group" },
                    [_vm._v("IP Address")]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-sm-12 col-xs-12 col-md-10 mb-10" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.ipAddress,
                            expression: "ipAddress",
                          },
                        ],
                        staticClass: "form-control",
                        class: _vm.displayIpErrorMsg ? "invalid-border" : "",
                        attrs: {
                          type: "text",
                          placeholder: "IP Address (xxx.xxx.xxx.xxx)",
                          disabled: _vm.member.is_restricted,
                        },
                        domProps: { value: _vm.ipAddress },
                        on: {
                          blur: _vm.ipAddressVal,
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.ipAddress = $event.target.value
                          },
                        },
                      }),
                      _vm.displayIpErrorMsg
                        ? _c("div", { staticClass: "custom-error-class" }, [
                            _c("span", [_vm._v("Invalid IP Address.")]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _c("div", { staticClass: "row mr-bt-5p" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12 col-md-12 form-group" },
              [_vm._v("Role")]
            ),
            _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-10" }, [
              _c(
                "div",
                { staticClass: "custom-dropdown mt-4" },
                [
                  _c("multiselect", {
                    staticClass: "multiselect-single-dropdown",
                    attrs: {
                      showLabels: false,
                      "close-on-select": true,
                      "allow-empty": false,
                      searchable: false,
                      options: _vm.roles.map((role) => role.id),
                      "custom-label": _vm.getRoleNameById,
                      placeholder: "Select Role",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.getRoleBasedTemplate(_vm.roleId)
                      },
                    },
                    model: {
                      value: _vm.roleId,
                      callback: function ($$v) {
                        _vm.roleId = $$v
                      },
                      expression: "roleId",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm.roleId == 6
            ? _c("div", { staticClass: "row mr-bt-5p" }, [
                _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-12" }, [
                  _vm._v("Distributor"),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-sm-12 col-xs-12 col-md-10 custom-dropdown",
                  },
                  [
                    _c("multiselect", {
                      staticClass: "multiselect-single-dropdown",
                      attrs: {
                        showLabels: false,
                        "close-on-select": true,
                        "allow-empty": false,
                        searchable: false,
                        options: _vm.distributors.map(
                          (distributor) => distributor.id
                        ),
                        "custom-label": (option) =>
                          _vm.distributors.find((x) => x.id === option)
                            .distributor_name,
                        placeholder: "Select Role",
                      },
                      model: {
                        value: _vm.distributorId,
                        callback: function ($$v) {
                          _vm.distributorId = $$v
                        },
                        expression: "distributorId",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
        _vm.userServiceList && _vm.userServiceList.length
          ? _c(
              "div",
              { staticClass: "col-md-12 col-sm-12 col-xs-12 pb-20" },
              [
                _vm._m(1),
                _vm._l(_vm.userServiceList, function (service, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "col-md-12 col-sm-12 col-xs-12 bt-border",
                    },
                    [
                      service.key != "REPRESENTATION_RESOURCES" ||
                      _vm.account_type_id != 3
                        ? _c("div", { staticClass: "row pb-8 pt-8" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-sm-7 col-xs-8 d-flex align-items-center",
                              },
                              [
                                _c("span", { staticClass: "checkbox mr-12" }, [
                                  _c("label", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: service.access,
                                          expression: "service.access",
                                        },
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        disabled:
                                          _vm.member.is_restricted ||
                                          !_vm.disablePermissionCheck(
                                            service.id
                                          ),
                                      },
                                      domProps: {
                                        checked: Array.isArray(service.access)
                                          ? _vm._i(service.access, null) > -1
                                          : service.access,
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$a = service.access,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    service,
                                                    "access",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    service,
                                                    "access",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(service, "access", $$c)
                                            }
                                          },
                                          function ($event) {
                                            return _vm.revertOldPermissions(
                                              service.id,
                                              service.access
                                            )
                                          },
                                        ],
                                      },
                                    }),
                                    _c("span", { staticClass: "cr" }),
                                  ]),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "cust_label",
                                    class: {
                                      "link-disabled":
                                        _vm.member.is_restricted ||
                                        !_vm.disablePermissionCheck(service.id),
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(service.name) + " ")]
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "col-sm-3 col-xs-4" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "edit-lnk",
                                  class: {
                                    "link-disabled":
                                      _vm.member.is_restricted ||
                                      !_vm.disablePermissionCheck(service.id) ||
                                      !service.access,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.disablePermissionCheck(service.id) &&
                                      service.access
                                        ? _vm.openPermissionsPopup(service)
                                        : null
                                    },
                                  },
                                },
                                [_vm._v(" edit ")]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
      !_vm.member.is_restricted
        ? _c(
            "div",
            {
              staticClass:
                "col-sm-12 col-xs-12 col-md-12 footer remove_button_padding",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-2 col-md-offset-7 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-white-button",
                      attrs: { type: "button" },
                      on: { click: _vm.cancelEditTeam },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-green-button",
                      attrs: {
                        type: "button",
                        disabled:
                          _vm.disableButtonForAddTeam || _vm.loaderStatus,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateTeamMember()
                        },
                      },
                    },
                    [_vm._v(" Save Changes ")]
                  ),
                ]
              ),
            ]
          )
        : _c(
            "div",
            {
              staticClass:
                "col-sm-12 col-xs-12 col-md-12 footer remove_button_padding",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-sm-offset-9 col-md-offset-10 col-xs-offset-7 col-md-2 col-sm-3 col-xs-5 xs-pd-lt-0",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-white-button",
                      attrs: { type: "button" },
                      on: { click: _vm.cancelEditTeam },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                ]
              ),
            ]
          ),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      _c("member-permissions", {
        attrs: {
          member: _vm.member.first_name + " " + _vm.member.last_name,
          serviceId: _vm.serviceId,
          userServiceList: _vm.userServiceList,
          rolesServicesList: _vm.servicesList,
        },
        on: { updateUserPermission: _vm.updateUserPermission },
      }),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "confirmaton_popup", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c(
                  "div",
                  { staticClass: "modal-header confirmpopup-bgcolor" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#confirmaton_popup",
                        },
                      },
                      [_vm._v(" × ")]
                    ),
                    _c("h4", { staticClass: "modal-title" }, [
                      _vm._v("Are you sure you want to unblock the member?"),
                    ]),
                    _c("p", { staticClass: "user-name" }, [
                      _vm._v(_vm._s(_vm.member.email)),
                    ]),
                    _c("p", { staticClass: "unblock-modal-content" }, [
                      _vm._v(
                        " By unblocking this user, you will utilize one (1) available Team Member subscription. The user will regain all previous access levels. "
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "modal-footer confirmpopup-bgcolor" },
                  [
                    _vm._m(2),
                    _c("div", { staticClass: "col-sm-6 col-xs-12 text-left" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn emergo-green-button btn-width-confirm",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.updateTeamMemberRestriction()
                            },
                          },
                        },
                        [_vm._v(" Yes, unblock user ")]
                      ),
                    ]),
                  ]
                ),
                _c("loader", {
                  attrs: { loadingStatus: _vm.confirmLoaderStatus },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-12" }, [
      _c("hr"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-12 col-sm-12 col-xs-12 pl-0 pr-0 bt-border" },
      [
        _c("div", { staticClass: "row pb-4" }, [
          _c("div", { staticClass: "col-sm-7 col-xs-6" }, [
            _vm._v("Services access"),
          ]),
          _c("div", { staticClass: "col-sm-3 col-xs-6 txt-alg-rt" }, [
            _vm._v("Permissions"),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-6 col-xs-12 txt-alg-rt" }, [
      _c(
        "button",
        {
          staticClass: "btn emergo-white-button btn-width-confirm",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#confirmaton_popup",
          },
        },
        [_vm._v(" Cancel ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }